import { useToast } from "@/components/ui/use-toast";
import { useCallback, useRef } from "react";

type ShowErrorToastParams = {
  title?: string;
  description: string;
};

export const useShowErrorToast = () => {
  const { toast } = useToast();
  const lastShownToastRef = useRef<{
    toast: ShowErrorToastParams;
    shownAt: Date;
  } | null>(null);

  // 同じ内容のtoastを1秒以内に連続して表示しないための判定
  const isShowable = ({
    toastParams,
    now,
  }: {
    toastParams: ShowErrorToastParams;
    now: Date;
  }) => {
    if (!lastShownToastRef.current) return true;

    if (
      lastShownToastRef.current.toast.title !== toastParams.title ||
      lastShownToastRef.current.toast.description !== toastParams.description
    ) {
      return true;
    }

    const timeSinceLastShown =
      now.getTime() - lastShownToastRef.current.shownAt.getTime();
    return timeSinceLastShown > 1000; // 1秒以上経過していれば表示する
  };

  const showErrorToast = useCallback(
    (params: ShowErrorToastParams) => {
      const now = new Date();
      const showable = isShowable({ toastParams: params, now });
      if (!showable) return;

      lastShownToastRef.current = {
        toast: params,
        shownAt: now,
      };
      toast({
        title: params.title ?? "エラー",
        description: params.description,
        variant: "error",
      });
    },
    [toast],
  );

  return { showErrorToast };
};
